import { useState, useEffect } from 'react'
import App from './App'
import { HowToPlay } from './components/info/HowToPlay'
import { Results } from './components/info/Results'

export const AppWrapper = () => {
  const [round, setRound] = useState(0)

  const updateGameGuesses = (round: number, guesses: number) =>
    localStorage.setItem(`round_guesses_${round}`, JSON.stringify(guesses))

  const updateRound = (roundNumber: number) => {
    localStorage.setItem('round', JSON.stringify(roundNumber))
    setRound(roundNumber)
  }

  const startTheGame = () => {
    localStorage.setItem('startTime', new Date().toString())
    updateRound(1)
  }

  const endTheGame = () => {
    localStorage.setItem('endTime', new Date().toString())
    updateRound(3)
  }

  useEffect(() => {
    const localRound = localStorage.getItem('round')
    console.log(localRound)

    if (localRound) {
      setRound(parseInt(localRound))
    } else {
      localStorage.setItem('round', JSON.stringify(0))
    }
  }, [])

  return (
    <>
      {round === 0 && <HowToPlay start={() => startTheGame()} />}

      {round === 1 && (
        <App
          round={round}
          updateGameGuesses={updateGameGuesses}
          finishCallback={() => updateRound(2)}
        />
      )}

      {round === 2 && (
        <App
          round={round}
          updateGameGuesses={updateGameGuesses}
          finishCallback={() => endTheGame()}
        />
      )}

      {round === 3 && <Results />}
    </>
  )
}

export default AppWrapper
